<app-modal [header]="'Alterar Privilégio'"
           [isShow]="displayModal"
           [style]="'w-full max-w-lg'"
           (cancel)="displayModal = false; this.onCancelModal.emit();">

  <div>

    <div class="text-xs mb-10 space-y-2"><p>Utilize o campo abaixo e escolha o novo privilégio que deseja dar ao utilizador {{user.firstname}} {{user.lastname}} ({{user.email}}) </p></div>

    <form method="POST" class="space-y-4" [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="my-10">

        <app-select-input [formGroup]="form" id="role" [options]="roles"
                          placeholder="Escolha o novo privilégio" label="Privilégios"
        ></app-select-input>

      </div>

      <hr>

      <!-- submit button -->
      <div class="flex justify-end">
        <app-ae-button variant="primary" label="Alterar" [loading]="isLoading"
                  (buttonClick)="onSubmit()" size="sm" styleClass="justify-end"></app-ae-button>
      </div>
    </form>
  </div>


</app-modal>


